import React from "react";

type LabelProps = {
	htmlFor: string;
	text: React.ReactNode;
};

export const Label = ({ htmlFor, text }: LabelProps) => {
	return <label htmlFor={htmlFor ?? ""}>{text}</label>;
};
